module.exports = __webpack_public_path__ + "static/media/banner-web-apple-non-ppfa@3x.34b0c095.png";